import { FC } from 'react'

import styled from 'styled-components'

import { renderLanguageOrGenreName } from 'src/Components/GenresList/helpers'
import { GroupedOption, SelectedLanguage } from 'src/Types/tracks'
import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'

const LanguageListContainer = styled.ul`
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`
export const LanguageListLabel = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  margin-bottom: 16px;
  margin-top: 16px;
`

interface Props {
  item: GroupedOption
  searchValue: string
  onClick: (item: SelectedLanguage) => void
  selectedLanguage?: SelectedLanguage | null
}

export const LanguagesModalSpotifyGroupedItem: FC<Props> = ({
  item,
  onClick,
  searchValue,
  selectedLanguage,
}) => {
  const { label, options } = item
  if (!options.length) {
    return null
  }
  return (
    <>
      <LanguageListLabel>{label}</LanguageListLabel>
      <LanguageListContainer>
        {options.map((language) => (
          <LabelForGenreOrLanguage
            key={language.value}
            title={renderLanguageOrGenreName(language.label, searchValue)}
            onClick={() => onClick(language)}
            hasCross={selectedLanguage?.value === language.value}
          />
        ))}
      </LanguageListContainer>
    </>
  )
}
